<template>
  <ion-page :class="['ion-page', layout_cls]">
    <FabColumn v-if="show_time">
      <div class="time">
        <div class="second">{{ second }}</div>
      </div>
    </FabColumn>
    <ion-content class="content">
      <div class="launch-content">
        <LaunchIcon :class="icon_cls"></LaunchIcon>
        <LaunchSponsor class="sponsor"></LaunchSponsor>
        <LaunchDonate class="donate"></LaunchDonate>
        <LaunchCooperate class="cooperate"></LaunchCooperate>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonContent, IonPage, isPlatform } from "@ionic/vue";
import common from '@/common';
import { App } from '@capacitor/app';
import LaunchIcon from "../components/launch/LaunchIcon";
import LaunchSponsor from "../components/launch/LaunchSponsor";
import LaunchDonate from "../components/launch/LaunchDonate";
import LaunchCooperate from "../components/launch/LaunchCooperate";
import router from "../router";
import { AndroidPermissions } from "@awesome-cordova-plugins/android-permissions";
import { Diagnostic } from "@awesome-cordova-plugins/diagnostic";
import forceUpdateAlert from '@/utils/forceUpdateAlert';

export default {
  name: "Launch",
  components: {
    LaunchCooperate,
    LaunchDonate,
    LaunchSponsor,
    LaunchIcon,
    IonPage,
    IonContent
  },
  props: {
    layout_cls: { type: String, default: '' },
    icon_cls: { type: String, default: 'icon' },
    show_time: { type: Boolean, default: true },
  },
  data() {
    return {
      monitor: null,
      inter: null,
      second: 5,
    }
  },
  async ionViewDidEnter() {
    if (isPlatform('hybrid') && isPlatform('android')) {
      // common.setStorage('navigation_height', window.screen.height - window.document.body.clientHeight);
      common.setStorage('navigation_height', 0);

      try {
        window.navigationbar.setUp(true, () => {
          window.navigationbar.hideNavigationBar(
            () => console.log('Hidden Navigation Success'),
            err => console.error('Hidden Navigation Error', err)
          );
        }, err => {
          console.error('NavigationBar SetUp Error', err);
        });
      } catch (e) {
        console.error('調用插件異常:', e);
      }
    } else {
      common.setStorage('navigation_height', 0);
    }

    const new_version = await forceUpdateAlert(this.countBackwards);
    if (new_version === 1) {
      this.monitor = App.addListener('appStateChange', state => {
        // 应用程序被激活，需要强制更新
        if (state.isActive) {
          forceUpdateAlert(this.countBackwards);
        }
      })
    }
  },

  ionViewWillLeave() {
    if (this.monitor !== null) {
      App.removeAllListeners();
    }
  },

  methods: {
    countBackwards: function () {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;
      this.inter = setInterval(function () {
        if (isPlatform('hybrid') && isPlatform('android')) {
          AndroidPermissions.checkPermission(AndroidPermissions.PERMISSION.RECORD_AUDIO).then(res => {
            if (res.hasPermission) {
              that.jump();
            }
          })
        } else if (isPlatform('hybrid') && isPlatform('ios')) {
          Diagnostic.isMicrophoneAuthorized().then(is_auth => {
            if (is_auth) {
              that.jump();
            }
          })
        } else {
          that.jump();
        }
      }, 1000);

    },

    jump: function () {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;
      clearInterval(this.inter)
      this.inter = setInterval(function () {
        that.second--;
        if (that.second <= 0) {
          clearInterval(that.inter);
          common.getToken().then(value => {
            if (value == null) {
              router.replace('/loginPrepare')
            } else {
              router.replace('/home')
            }
          })
        }
      }, 1000);
    }
  }
}
</script>

<style scoped>
.content {
  background: white;
}

.launch-content {
  box-sizing: border-box;
  min-height: 100%;
  padding: clamp(1rem, 2vh, 2rem) 0;
}

.icon {
  height: 10rem;
  margin-bottom: 1rem;
  margin-top: 1rem;
}

.icon-short {
  height: 24vh;
}

.about-launch {
  position: relative;
  width: 100%;
  height: 100%;
  contain: content;
}

.about-launch .content {
  --background: transparent;
}

.about-launch .launch-content {
  position: absolute;
  inset: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 0;
  padding: 0;
  overflow: hidden;
}

.about-launch .sponsor,
.about-launch .donate,
.about-launch .cooperate {
  width: auto;
  height: 10vh;
}

.about-icon {
  height: 24vh;
}

.about-launch .sponsor {
  margin-top: 3vh;
}

.about-launch .donate {
  margin-top: 6vh;
}

.about-launch .cooperate {
  margin-top: 6vh;
}

.about-launch :deep(.text) {
  font-size: 2vh;
}

.about-launch .sponsor :deep(.img) {
  width: auto;
  height: 80%;
  margin-top: 1vh;
}

.about-launch .donate :deep(.img) {
  width: auto;
  height: 60%;
  margin-top: 1vh;
}

.about-launch .cooperate :deep(.img) {
  display: block;
  width: auto;
  height: 40%;
  margin: 1vh auto;
}

.sponsor {
  box-sizing: border-box;
  width: 12rem;
  height: auto;
  margin-top: 2rem;
}

.donate {
  box-sizing: border-box;
  width: 15rem;
  height: auto;
  margin-top: 2rem;
}

.cooperate {
  box-sizing: border-box;
  width: 18rem;
  height: auto;
  margin-top: 2rem;
}

.sponsor,
.donate,
.cooperate {
  margin-left: auto;
  margin-right: auto;
}

.sponsor :deep(.text),
.donate :deep(.text),
.cooperate :deep(.text) {
  margin-bottom: clamp(0.375rem, 1vw, 0.625rem);
  line-height: 1.3;
}

.sponsor :deep(.img),
.donate :deep(.img),
.cooperate :deep(.img) {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto;
  object-fit: contain;
}

.time {
  box-sizing: border-box;
  border: #c7c7c7 2px solid;
  border-radius: 999px;
  height: clamp(2.5rem, 4.6vw, 3.25rem);
  width: clamp(2.5rem, 4.6vw, 3.25rem);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
}

.second {
  margin: 0;
  text-align: center;
  font-size: var(--ecs-font-md);
  line-height: 1;
  color: black;
}

@media (orientation: landscape) and (max-height: 480px) {
  .time {
    height: clamp(2.45rem, 4.4vw, 2.85rem);
    width: clamp(2.45rem, 4.4vw, 2.85rem);
  }
}
</style>
